import React from 'react';
import { Color } from '../types/Color';
import { Button, ButtonGroup, FormLabel } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../store';
import { setParams } from '../reducers/paramsReducer';

export default function GamesFiltersColor(): React.ReactNode {
  const { color } = useAppSelector((state) => state.paramsReducer.params);
  const dispatch = useAppDispatch();

  const go = (c?: Color) => {
    if (c != color) {
      dispatch(setParams({ color: c ?? null }));
    }
  };

  return (
    <>
      <FormLabel className="d-block">Played as</FormLabel>
      <ButtonGroup className="cm-segmented">
        <Button variant="outline-primary" active={color == null} onClick={() => go()}>
          Either
        </Button>
        <Button
          variant="outline-primary"
          active={color == Color.White}
          onClick={() => go(Color.White)}
        >
          White
        </Button>
        <Button
          variant="outline-primary"
          active={color == Color.Black}
          onClick={() => go(Color.Black)}
        >
          Black
        </Button>
      </ButtonGroup>
    </>
  );
}
